import React, { MouseEventHandler } from "react";
import { Button as MuiButton } from "@mui/material";
import Loading from "./Loading/Loading";
interface Props {
  variant: "contained" | "outlined";
  onClick: () => void;
  text: string | JSX.Element;
  className?: string;
  type?: "submit";
  disabled?: boolean;
  loading?: boolean;
}

const Button: React.FC<Props> = ({
  variant,
  onClick,
  text,
  className,
  disabled,
  loading,
}) => {
  const onButtonClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    e.stopPropagation();
    if (loading) return;
    onClick();
  };

  return (
    <MuiButton
      disabled={disabled || false}
      variant={variant}
      onClick={(e) => onButtonClick(e)}
      className={`whitespace-nowrap	${className}`}
      fullWidth
      type="button"
    >
      {loading ? <Loading /> : text}
    </MuiButton>
  );
};

export default Button;
